import { useState } from 'react';
import { PLANS } from '../lib/constants.js';
import { Btn } from '../components/Basic.jsx';
import { t as tr } from '../lib/i18n.js';
export function SubscriptionView({t,st,dispatch,go}){
  const [confirmed,setConfirmed]=useState(null);
  return(
    <div className="screen fade" style={{background:t.bg}}>
      <div style={{padding:"14px 16px 8px",display:"flex",alignItems:"center",gap:11,flexShrink:0}}>
        <div onClick={()=>go("settings")} style={{width:32,height:32,borderRadius:"50%",background:t.card,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:14,color:t.tx}}>←</div>
        <span style={{fontSize:17,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{tr("sub_header_title")}</span>
      </div>
      <div style={{padding:"10px 16px 6px",textAlign:"center"}}>
        <div style={{fontSize:20,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif",marginBottom:6}}>{tr("sub_title")}</div>
        <div style={{fontSize:12,color:t.soft,fontFamily:"Inter,sans-serif",lineHeight:1.6}}>{tr("sub_subtitle")}</div>
      </div>
      <div style={{padding:"16px 16px 40px",display:"flex",flexDirection:"column",gap:14,flex:1}}>
        {PLANS.map(plan=>{
          const isCurrent=st.settings.plan===plan.id;
          return(
            <div key={plan.id} style={{
              background:plan.highlight?"linear-gradient(160deg,#1A0A2E,#2D0A3E)":t.card,
              borderRadius:20,
              padding:"20px 18px",
              border:plan.highlight?"2px solid #FF2D6B":`1px solid ${t.bord}`,
              position:"relative",
              boxShadow:plan.highlight?"0 8px 28px rgba(255,45,107,.28)":"none",
              transform:plan.highlight?"scale(1.02)":"none",
            }}>
              {plan.badge&&(
                <div style={{position:"absolute",top:-11,left:"50%",transform:"translateX(-50%)",background:"linear-gradient(135deg,#FF2D6B,#7B2FFF)",color:t.tx,fontSize:10,fontWeight:800,fontFamily:"Inter,sans-serif",padding:"5px 14px",borderRadius:20,letterSpacing:"0.5px",boxShadow:"0 3px 10px rgba(255,45,107,.4)"}}>★ {plan.badge}</div>
              )}
              <div style={{display:"flex",alignItems:"baseline",justifyContent:"space-between",marginBottom:4,marginTop:plan.badge?4:0}}>
                <div style={{fontSize:17,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{plan.name}</div>
                {isCurrent&&<span style={{fontSize:9,padding:"3px 9px",borderRadius:20,background:t.card,color:t.tx,fontFamily:"Inter,sans-serif",fontWeight:700}}>{tr("sub_current_badge")}</span>}
              </div>
              <div style={{display:"flex",alignItems:"baseline",gap:5,marginBottom:14}}>
                <span style={{fontSize:28,fontWeight:900,color:t.tx,fontFamily:"Inter,sans-serif"}}>{plan.price}</span>
                <span style={{fontSize:12,color:t.soft,fontFamily:"Inter,sans-serif"}}>{plan.period}</span>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:18}}>
                {plan.features.map((f,i)=>(
                  <div key={i} style={{display:"flex",alignItems:"flex-start",gap:8}}>
                    <span style={{color:plan.highlight?"#FF2D6B":"#5CE0A0",fontSize:13,marginTop:1}}>✓</span>
                    <span style={{fontSize:12.5,color:t.soft,fontFamily:"Inter,sans-serif",lineHeight:1.4}}>{f}</span>
                  </div>
                ))}
              </div>
              <Btn full fn={()=>{
                if(isCurrent)return;
                setConfirmed(plan.name);
              }} style={{
                background:isCurrent?t.card:plan.highlight?"linear-gradient(135deg,#FF2D6B,#7B2FFF)":t.card,
                color:t.tx,padding:"13px",borderRadius:40,fontSize:13,fontWeight:700,fontFamily:"Inter,sans-serif",textAlign:"center",
                opacity:isCurrent?.6:1,
              }}>{isCurrent?tr("sub_btn_active"):plan.id==="free"?tr("sub_btn_switch_free"):tr("sub_btn_activate",{plan:plan.name})}</Btn>
            </div>
          );
        })}
        <div style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif",textAlign:"center",marginTop:4,lineHeight:1.6}}>{tr("sub_footer_note")}</div>
      </div>
      {confirmed&&(
        <div className="overlay" onClick={()=>setConfirmed(null)}>
          <div className="sheet" onClick={e=>e.stopPropagation()} style={{textAlign:"center",padding:"36px 24px"}}>
            <div style={{fontSize:44,marginBottom:14}}>🚧</div>
            <div style={{fontSize:17,fontWeight:800,color:"#1a1a1a",fontFamily:"Inter,sans-serif",marginBottom:8}}>{tr("sub_coming_title")}</div>
            <div style={{fontSize:12,color:"#888",fontFamily:"Inter,sans-serif",marginBottom:20,lineHeight:1.6}}>{tr("sub_coming_body",{plan:confirmed})}</div>
            <Btn fn={()=>{setConfirmed(null);go("settings");}} style={{background:"linear-gradient(135deg,#FF2D6B,#7B2FFF)",color:t.tx,padding:"13px 30px",borderRadius:40,fontSize:13,fontWeight:700,fontFamily:"Inter,sans-serif",display:"inline-block"}}>{tr("sub_coming_ok")}</Btn>
          </div>
        </div>
      )}
    </div>
  );
}
